import type { GambitSearchResultDto } from '@/views/composables/models/components/GambitSearchResultDto';
import { SparkDay } from '@/views/composables/models/main/Spark';
import {
  format,
  getDay,
  isAfter,
  isBefore,
  nextFriday,
  nextMonday,
  nextSaturday,
  nextSunday,
  nextThursday,
  nextTuesday,
  nextWednesday,
  setHours,
} from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

export const toWallDate = (date: Date | string) => {
  return format(date, 'yyyy-MM-dd');
};

export const toWallDateTime = (date: Date | string) => {
  return format(date, "yyyy-MM-dd'T'HH:mm:ss.SSS");
};

export const getSparkDay = (day: SparkDay, now: Date) => {
  const todayDay = getDay(now);

  switch (day) {
    case SparkDay.SUNDAY:
      return todayDay === 0 ? now : nextSunday(now);
    case SparkDay.MONDAY:
      return todayDay === 1 ? now : nextMonday(now);
    case SparkDay.TUESDAY:
      return todayDay === 2 ? now : nextTuesday(now);
    case SparkDay.WEDNESDAY:
      return todayDay === 3 ? now : nextWednesday(now);
    case SparkDay.THURSDAY:
      return todayDay === 4 ? now : nextThursday(now);
    case SparkDay.FRIDAY:
      return todayDay === 5 ? now : nextFriday(now);
    case SparkDay.SATURDAY:
      return todayDay === 6 ? now : nextSaturday(now);
    default:
      throw Error('Expected week to have 7 days.');
  }
};

export function getGambitsForDay(gambits: GambitSearchResultDto[], date: string): GambitSearchResultDto[] {
  return gambits.filter((gambit) => {
    const gambitStart = toZonedTime(gambit.start, gambit.timezone || 'UTC');
    const gambitEnd = toZonedTime(gambit.end, gambit.timezone || 'UTC');

    const dayStart = setHours(toZonedTime(date, gambit.timezone || 'UTC'), 10);
    const dayEnd = setHours(toZonedTime(date, gambit.timezone || 'UTC'), 22);

    return isAfter(gambitEnd, dayStart) && isBefore(gambitStart, dayEnd);
  });
}
